<template>
  <footer>
    <div class="footer-logo">
      <img src="@/assets/logo.svg" alt="logo" class="footer-logo-img" />
      <span class="logo-text">宝能卓越</span>
      <span class="logo-accent">iSmartSys</span>
    </div>

    <div class="footer-copyright">{{ data.copyright }}</div>

    <div class="footer-beian">
      <a href="https://beian.miit.gov.cn" target="_blank" class="beian-link">
        京ICP备2023009406号-1
      </a>
      <a
        target="_blank"
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11030102011529"
        class="police-link"
      >
        <img src="~@/assets/备案图标.png" alt="备案图标" />
        京公网安备 11030102011529号
      </a>
    </div>

    <div class="footer-address">{{ data.address }}</div>
  </footer>
</template>

<script setup>
import { ref } from "vue";

const data = ref({
  copyright: "",
  address:
    "公司办公地址：北京市经济技术开发区永昌中路8号中科经纬产业园2号楼2001",
});

data.value.copyright = `© ${new Date().getFullYear()} 北京宝能卓越科技有限公司 | 邮箱：service@ismartsys.com | 电话：010-67885726`;
</script>

<style scoped lang="scss">
@import "@/assets/scss/_variables.scss";

footer {
  width: 100%;
  color: rgba(255, 255, 255, 0.7);
  padding: 40px 20px;
  text-align: center;
  box-sizing: border-box;
  transition: color 0.3s ease;
}

.footer-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 15px;
  letter-spacing: 1px;
}

.logo-text {
  color: $color-white;
  transition: color 0.3s ease;
}

.logo-accent {
  color: var(--accent-color);
}

.footer-logo-img {
  height: 30px;
  width: auto;
}

.footer-copyright {
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.8;
  margin-bottom: 8px;
  transition: color 0.3s ease;
}

.footer-beian {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 8px;
}

.beian-link,
.police-link {
  text-decoration: none;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.9rem;
  line-height: 20px;
  display: inline-flex;
  align-items: center;
  transition: color 0.3s ease;
}

.beian-link:hover,
.police-link:hover {
  color: var(--accent-color);
}

.police-link img {
  height: 20px;
  margin-right: 5px;
  vertical-align: middle;
}

.footer-address {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.8;
  transition: color 0.3s ease;
}

@media (max-width: $breakpoint-mobile) {
  footer {
    padding: 30px 15px;
  }

  .footer-logo {
    font-size: 20px;
  }

  .footer-copyright {
    font-size: 0.85rem;
  }

  .footer-beian {
    gap: 12px;
  }

  .beian-link,
  .police-link {
    font-size: 0.85rem;
  }

  .footer-address {
    font-size: 0.8rem;
  }
}
</style>
